import _sfc_main from "./index.vue2.mjs";
import "./index.vue3.mjs";
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _vm.streamInfo ? _c(_setup.StreamRegion, { attrs: { "stream-info": _vm.streamInfo, "fill-mode": _vm.fillMode, "support-touch-scale": _vm.supportTouchScale, "stream-play-quality": _setup.StreamPlayQuality.HIGH, "aspect-ratio": _setup.aspectRatio }, on: { "stream-view-dblclick": function($event) {
    return _vm.$emit("stream-view-dblclick");
  } } }) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "0ddc3aba"
);
const SingleStreamView = __component__.exports;
export {
  SingleStreamView as default
};
